var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M3.5 20.125C3.5 21.16 4.316 22 5.321 22H18.68c1.005 0 1.821-.84 1.821-1.875V9.5h-17v10.625zm2.429-7.5c0-.344.273-.625.607-.625h3.643c.333 0 .607.281.607.625v3.75a.618.618 0 01-.607.625H6.536a.618.618 0 01-.607-.625v-3.75zM18.679 4.5h-1.822V2.625A.618.618 0 0016.25 2h-1.214a.618.618 0 00-.607.625V4.5H9.57V2.625A.618.618 0 008.963 2H7.75a.618.618 0 00-.607.625V4.5H5.32c-1.004 0-1.82.84-1.82 1.875V8.25h17V6.375c0-1.035-.816-1.875-1.821-1.875z"
  }))));
}

export default SvgCalender;